<template>
  <ark-leaderboard ark-test-id='leaderboard-widget' class='ark-leaderboard'>
    <tabs
      :tabs='config.tabs'
      :chosenPeriod.sync='chosenPeriod'
    ></tabs>

    <ark-div class='ark-leaderboard__body'>

      <ark-preload v-if='!leaderboardData' class='ark-leaderboard__loader'></ark-preload>

      <leaderboard-content
        v-if='leaderboardData'
        :leaderboardData='leaderboardData'
        :chosenPeriod='chosenPeriod'
        :emptyLeaderboardText='config.emptyLeaderboardText'
      ></leaderboard-content>
    </ark-div>
  </ark-leaderboard>
</template>
<script>

import Tabs from '../Tabs/Tabs.vue'
import LeaderboardContent from '../LeaderboardContent/LeaderboardContent'

export default {
  components: {Tabs, LeaderboardContent},
  name: 'leaderboardWidget',
  props: ['config'],
  data () {
    return {
      chosenPeriod: 'today',
      leaderboardData: null
    }
  },
  created: function () {
    // get cached leaderboard on init
    this.$http.get(`${this.config.apiUrl}/Leaderboard/Get/${this.config.externalGameId}`).then(response => {
      this.leaderboardData = response.body
    }, error => {
      console.log(`Error ${error.status} ${error.statusText} leaderboard data`)
    })

    // on refresh, getting leaderboard data without cache
    this.$parent.$on('refreshLeaderboard', (data) => {
      if (typeof data === 'undefined') {
        return
      }
      let shouldUpdate = true
      // if there is a score, first we calculate, should we refresh leaderboard or not
      if (data.score && this.leaderboardData && this.leaderboardData['today']) {
        shouldUpdate = this.leaderboardData['today'].length &&
        this.leaderboardData['today'].length === this.config.usersLimit
          ? this.leaderboardData['today'].every((elem) => {
            return data.score > elem.value
          }) : true
      }

      if (shouldUpdate) {
        this.$http.get(`${this.config.apiUrl}/Leaderboard/GetWithoutCache/${data.gameId}`).then(response => {
          this.leaderboardData = response.body
        }, error => {
          console.log(`Error ${error.status} ${error.statusText} leaderboard data`)
        })
      }
    })
  }
}
</script>

<style lang="scss" src="./MainLeaderboard.scss"></style>



// WEBPACK FOOTER //
// MainLeaderboard.vue?6c6e5be2